import React, { Component } from "react";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

import { getMessage } from "CONFIG/i18n";
import { validateSetPassword } from "UTILS/regexValidations";

import "../SuperAdmin/Organisations/AddOrganization.less";
import "../SuperAdmin/Users/AdminDashboard.less";
import "../App/App.less";
import "./ChangePassword.less";
import modalScrollBar from "../ModalScrollBar/ModalScrollBar";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.isIE = /*@cc_on!@*/false || !!document.documentMode;
    this.state = {
      errorMessage: "",
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      isChangeDisabled: false,
      networkError: this.props.networkError,
      screenWidth: window.innerWidth,
    };
    window.addEventListener('resize', this.updateSize);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.networkError !== this.props.networkError) {
      this.setState({ errorMessage: this.props.networkError });
    }
    if (
      this.props.errorMessage === "Network Error" &&
      this.state.isChangeDisabled === true
    ) {
      this.setState({ isChangeDisabled: false });
    }
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.updateSize);
  }

  updateSize = (event) =>{
    this.setState({screenWidth: window.innerWidth});
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value.trim(),
      errorMessage: "",
      isChangeDisabled: false
    });
  };

  enterPressed = event => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      this.handleChangePasswordClick();
    }
  };

  handleChangePasswordClick = () => {
    let errorMessage="";
    if(!this.state.oldPassword)
      errorMessage = getMessage("ENTER_OLD_PASSWORD")
    else if(!this.state.newPassword)
      errorMessage = getMessage("ENTER_NEW_PASSWORD")
    else if(!this.state.confirmPassword)
      errorMessage = getMessage("ENTER_CONFIRM_PASSWORD")
    else
      errorMessage = validateSetPassword(
        this.state.newPassword,
        this.state.confirmPassword
      );

    // errorMessage = this.state.oldPassword === this.state.newPassword
    //   ? getMessage("OLD_NEW_PASSWORD_MATCH_MEG") : errorMessage;

    if (errorMessage) {
      this.setState({ errorMessage: errorMessage });
    } else {
      this.setState({ isChangeDisabled: true });
      let request_data = {
        oldPassword: this.state.oldPassword,
        newPassword: this.state.newPassword,
        confirmPassword: this.state.confirmPassword,
        language: this.props.language,
      };
      this.props.handleChangePassword(request_data, (message) => {
        if (message.resp !== "success") {
          errorMessage = getMessage(message.error.code, { ...message.error.details });
          this.setState({
            errorMessage: errorMessage
          });
        } else {
          this.setState({
            errorMessage: "",
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          })
        }
      });
    }
  };

  toggleModal = () => {
    this.setState({ errorMessage: "",
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
    this.props.toggleModal();
  };

  renderButtons = () => {
    return (
      <div className="permissionButtons">
        { !this.props.isSystemPassword ?
          <Button
            className="buttons borderBtn bgwhite"
            onClick={this.toggleModal}
          >
            {getMessage("CANCEL")}
          </Button> :
          ""
        }
        {" "}
        <Button onClick={this.handleChangePasswordClick} className="buttons customBtn whiteOnClick">
          {getMessage("CHANGE")}
        </Button>
      </div>
    );
  };

  setCursorOnFirstInputFieldForIE = () => {
    this.isIE && setTimeout(() => {
      document.getElementById("oldPassword").focus();
    }, 300);
  }

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        className="addOrganisationModal userAddModal passwordChangeModal modalMainDiv modal-width-50"
        toggle={this.toggleModal}
        backdrop="static"
        autoFocus={false}
        onOpened={this.setCursorOnFirstInputFieldForIE}
        centered
      >
        <ModalHeader className="popupHeader p-2">
          <div className="d-flex justify-content-center">{getMessage("CHANGE_PASSWORD")}</div>
          { this.props.isSystemPassword ?
            <div className="d-flex justify-content-center py-2">{getMessage("CHANGE_SYSTEM_PASSWORD_MESSAGE")}</div> :
            ""
          }
        </ModalHeader>
        <ModalBody>
          <Form>

            <FormGroup className="d-flex">
              <Label className="label modal-label col-md-3 col-4">{getMessage("OLD_PASSWORD")}</Label>
              <Input
                type="password"
                name="oldPassword"
                id="oldPassword"
                className="inputFormControl col-md-9 col-7"
                onChange={this.handleInputChange}
                onKeyPress={this.enterPressed}
                autoFocus={!this.isIE}
                required
                value={this.state.oldPassword}
              />
            </FormGroup>

            <FormGroup className="d-flex">
              <Label className="label modal-label col-md-3 col-4">{getMessage("NEW_PASSWORD")}</Label>
              <Input
                type="password"
                name="newPassword"
                id="newPassword"
                className="inputFormControl col-md-9 col-7"
                onChange={this.handleInputChange}
                onKeyPress={this.enterPressed}
                required
                value={this.state.newPassword}
              />
            </FormGroup>

            <FormGroup className="d-flex">
              <Label className="label modal-label col-md-3 col-4">{getMessage("RESET_CONFIRM_PASSWORD")}</Label>
              <Input
                type="password"
                name="confirmPassword"
                id="confirmPassword"
                className="inputFormControl col-md-9 col-7"
                onChange={this.handleInputChange}
                onKeyPress={this.enterPressed}
                required
                value={this.state.confirmPassword}
              />
            </FormGroup>
            <div className="modal-errors">{this.state.errorMessage}</div>
          </Form>
        </ModalBody>
        <ModalFooter className="permissionButtons">
          {this.renderButtons()}
        </ModalFooter>
      </Modal>
    );
  }
}
export default modalScrollBar(ChangePassword);
